import { useMutation } from '@apollo/client';
import { Form, Formik } from 'formik';
import React from 'react';
import TabLayout from 'routes/Users/components/UsersList/UserDetailDrawer/ClientViewTabs/TabLayout';
import { UPDATE_LOCATION } from 'services/graphql/mutations/location';
import { defaultNotification } from 'utils';
import * as Yup from 'yup';

import { useLocationFormProps } from '../../LocationForm/hooks';
import LocationFormBasic from '../../LocationForm/LocationFormBasic';
import { ILocationTabDetailProps } from '../types';
import { ILocationDetailSubmitValue } from './types';

const LocationGeneralInformation: React.FC<ILocationTabDetailProps> = ({ location, refetchLocationData }) => {
  const [updateLocation, { loading }] = useMutation(UPDATE_LOCATION);

  const { locationGeneralInformationFormProps, locationGeneralInformationInitialValues } = useLocationFormProps({
    location,
  });

  const callUpdateLocationMutation = async (v: ILocationDetailSubmitValue) => {
    // replace only the first contact
    const { name, number, ...address } = v;

    try {
      await updateLocation({
        variables: {
          filter: {
            id: location.id,
          },
          updatedDoc: {
            name,
            number,
            address,
          },
        },
      });
      defaultNotification({ success: 'Update User Successfully!' });
      refetchLocationData?.();
    } catch (err) {
      defaultNotification({ failure: true });
    }
  };

  const onSubmit = (v: ILocationDetailSubmitValue) => {
    callUpdateLocationMutation(v);
  };

  return (
    <Formik
      onSubmit={onSubmit}
      validationSchema={Yup.object({
        name: Yup.string().required('Required'),
        number: Yup.string().validatePhoneNumber('Wrong format'),
        address1: Yup.string().required('Required'),
        city: Yup.string().required('Required'),
        state: Yup.string().required('Required'),
        zip: Yup.string().required('Required'),
      })}
      initialValues={locationGeneralInformationInitialValues}
      enableReinitialize>
      {(props) => (
        <Form className='h-full'>
          <TabLayout loading={loading} onClick={props.handleSubmit}>
            <LocationFormBasic inputProps={locationGeneralInformationFormProps} />
          </TabLayout>
        </Form>
      )}
    </Formik>
  );
};

export default React.memo(LocationGeneralInformation);
